import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=2d5b871c&"
import script from "./Household.vue?vue&type=script&lang=js&"
export * from "./Household.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Household.vue?vue&type=custom&index=0&blockType=NavigationTabs"
if (typeof block0 === 'function') block0(component)

export default component.exports